import React from "react";
import { FiPhoneCall, FiMail } from "react-icons/fi";
import { MdOutlineLocationOn } from "react-icons/md";
import { MdKeyboardArrowRight } from "react-icons/md";

function Contact() {
  return (
    <div>
      <div className="container mx-auto relative">
        <h1 className="sm:hidden self-start mt-16 font-extrabold text-2xl inline-block border-b-2 border-second">
          Əlaqə
        </h1>

        <form className="contacts my-16 sm:mb-0 md:flex">
          <div className="contact text-second md:flex sm:hidden flex-col gap-y-7">
            <div className="phone flex gap-x-7 items-center">
              <div className="p-2 border-2 border-second border-dashed rounded-lg">
                <FiPhoneCall size={24} />
              </div>
              <div className="words flex flex-col justify-center">
                <h1 className="text-xl ">Telefon</h1>
                <p>+994 50 764 88 50</p>
              </div>
            </div>

            <div className="email flex gap-x-7 items-center">
              <div className="p-2 border-2 border-second border-dashed rounded-lg">
                <FiMail size={24} />
              </div>
              <div className="words flex flex-col justify-center">
                <h1 className="text-xl ">Email</h1>
                <p>suleymanismayilov8@gmail.com</p>
              </div>
            </div>

            <div className="address flex gap-x-7 items-center">
              <div className="p-2 border-2 border-second border-dashed rounded-lg">
                <MdOutlineLocationOn size={24} />
              </div>
              <div className="words flex flex-col justify-center">
                <h1 className="text-xl ">Ünvan</h1>
                <p>Baku, Azərbaycan</p>
              </div>
            </div>
          </div>

          <div className="md:block sm:hidden border-l-2 border-gray-200 h-60 absolute left-[40%] ml-3 "></div>

          <div className="inputs md:ml-52 sm:ml-0 md:flex gap-x-10 items-center justify-center relative">
            <h1 className="font-extrabold md:absolute top-0 left-0 text-xl sm:text-center">
              Suallarınız var?
            </h1>
            {/* INPUT 1 */}

            <div className="input1 flex flex-col gap-y-4 sm:items-center self-start mt-14">
              <input
                required
                placeholder="Adınız və Soyadınız"
                className="border md:text-xs sm:text-md px-5 py-3 rounded-lg sm:text-center "
                type="text"
              />
              <input
                required
                placeholder="Email ünvanı"
                className="sm:text-center border md:text-xs sm:text-md px-5 py-3 rounded-lg"
                type="email"
              />
              <input
                required
                placeholder="Telefon nömrəsi"
                className="sm:text-center border md:text-xs sm:text-md px-5 py-3 rounded-lg"
                type="number"
              />
            </div>

            {/* INPUT 2 */}

            <div className="input2 flex flex-col justify-center md:items-start sm:items-center gap-y-6 md:mt-14 sm:mt-5">
              <textarea
                required
                rows="4"
                cols="20"
                className="resize-none border rounded-lg md:text-sm sm:text-md px-5 md:py-2  sm:text-center"
                placeholder="Mesajınız..."
              ></textarea>
              <button
                type="submit"
                className="mt-1 mb-16 flex justify-center items-center rounded-md md:w-28 sm:w-24 text-white bg-first px-5 py-2"
              >
                Göndər
                <MdKeyboardArrowRight className="self-center ml-2 mb-1 text-2xl" />
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Contact;
